import React, { useEffect, useState } from 'react';
import { PhoneIcon, MenuIcon, XIcon } from 'lucide-react';
import { business } from '../data/business';
import { useLanguage } from '../contexts/LanguageContext';
import { LanguageToggle } from './LanguageToggle';
export function Header() {
  const {
    t
  } = useLanguage();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const links = [{
    href: '#nosotros',
    label: t.nav.about
  }, {
    href: '#servicios',
    label: t.nav.services
  }, {
    href: '#barberos',
    label: t.nav.barbers
  }, {
    href: '#galeria',
    label: t.nav.gallery
  }, {
    href: '#como-funciona',
    label: t.nav.how
  }, {
    href: '#agendar',
    label: t.nav.book
  }, {
    href: '#ubicacion',
    label: t.nav.location
  }];
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`fixed inset-x-0 top-0 z-50 border-b bg-ink/95 backdrop-blur transition-colors duration-200 ease-out ${scrolled || open ? 'border-gold/25' : 'border-white/5'}`} data-id="element-170" data-mp="2wldwxpm955aa">
      <div className="mx-auto flex max-w-content items-center justify-between gap-4 px-5 py-3 lg:px-8" data-id="element-171" data-mp="2mnpz2qtcnhnw">
        <a href="#inicio" className="flex items-center gap-3" data-id="element-172" data-mp="2hon4y1ewqvup">
          <img src={business.logo} alt={`Logo ${business.name}`} className="h-12 w-12 rounded-full object-cover ring-1 ring-gold/40 lg:h-14 lg:w-14" data-id="element-173" data-mp="3fb2nl6j2lzju" />
          <span className="leading-tight" data-id="element-174" data-mp="35l9bm4f0nif2">
            <span className="block font-display text-lg font-semibold uppercase tracking-wide text-cream lg:text-xl" data-id="element-175" data-mp="35k7yluefwlup">
              Haircuts Factory
            </span>
            <span className="block text-[11px] uppercase tracking-[0.2em] text-gold" data-id="element-176" data-mp="1wzbifz3rlgn">
              {t.header.locationLabel}
            </span>
          </span>
        </a>

        <nav aria-label={t.nav.about} className="hidden items-center gap-6 xl:flex" data-id="element-177" data-mp="3t9adiuhow0li">
          {links.map(link => <a key={link.href} href={link.href} className="text-sm font-medium text-cream/75 transition-colors duration-150 ease-out hover:text-gold-light" data-id="element-178" data-mp="1wceei1qz0uvz">
              {link.label}
            </a>)}
        </nav>

        <div className="flex items-center gap-2" data-id="element-179" data-mp="18n3ckgxvwug9">
          <LanguageToggle data-id="element-180" data-mp="18maee4czrd9q" />
          <a href={business.phoneHref} className="hidden items-center gap-2 rounded-sm bg-gold px-5 py-3 font-display text-sm font-semibold uppercase tracking-wider text-ink transition-colors duration-150 ease-out hover:bg-gold-light sm:flex" data-id="element-181" data-mp="18p6bjqh0lxx4">
            <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-182" data-mp="13oim398fpp50" />
            {t.header.call}
          </a>
          <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-label={open ? t.header.closeMenu : t.header.openMenu} className="flex h-11 w-11 items-center justify-center rounded-sm border border-gold/30 text-cream xl:hidden" data-id="element-183" data-mp="2t3ghuf7kefzr">
            {open ? <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-184" data-mp="w4zmbraz1h9q" /> : <MenuIcon className="h-5 w-5" aria-hidden="true" data-id="element-185" data-mp="rdrdoxhgtzxm" />}
          </button>
        </div>
      </div>

      {open && <nav aria-label={t.nav.services} className="border-t border-gold/15 bg-ink px-5 pb-5 pt-2 xl:hidden" data-id="element-186" data-mp="1544kuxmj9alw">
          {links.map(link => <a key={link.href} href={link.href} onClick={() => setOpen(false)} className="block border-b border-white/5 py-3 font-display text-base uppercase tracking-wide text-cream/85" data-id="element-187" data-mp="1f3veyy76lnlg">
              {link.label}
            </a>)}
        </nav>}
    </header>;
}